const initialState = {
  invoices: [],
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
  },
  filters: {
    status: null,
  },
  loading: false,
  error: null,
};

export const projectInvoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PROJECT_INVOICES':
      return {
        ...state,
        invoices: action?.payload?.invoices || [],
        pagination: {
          ...state.pagination,
          ...action?.payload?.pagination,
        },
        loading: false,
        error: null,
      };
    case 'GET_PROJECT_INVOICES_ERROR':
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    case 'SET_INVOICE_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action?.payload,
        },
      };
    case 'RESET_INVOICE_FILTERS':
      return {
        ...state,
        filters: initialState.filters,
      };
    default:
      return state;
  }
};

export default projectInvoicesReducer;


